import { DatasetCreationEnum } from '~/api/types';
import { useGetDatasetEnumsQuery } from '~/api/v2/hooks';
import { MultipleSelect, SelectOption } from '~/components';
import { useHasLockedStatus } from '~/hooks/dataset';

const RestrictionTagField = () => {
  const { data, isFetching } = useGetDatasetEnumsQuery({ enumKey: DatasetCreationEnum.RESTRICTION });
  const { hasLockedStatus } = useHasLockedStatus();

  const selectOptions: SelectOption[] =
    data?.map(({ key, value }) => ({
      value: key,
      label: value,
    })) || [];

  return (
    <MultipleSelect
      name="restriction_tag"
      label="RESTRICTION TAG"
      options={selectOptions}
      placeholder="Select the restriction tag"
      disabled={hasLockedStatus || isFetching}
    />
  );
};

export default RestrictionTagField;
